<template>
  <div class="contact-form general">
    <div class="form-row">
      <RadioButtonGroup inline>
        <RadioButton :label="labels.get('Mr')" value="Mr." v-model="formData.title"></RadioButton>
        <RadioButton :label="labels.get('Mrs')" value="Ms." v-model="formData.title"></RadioButton>
        <RadioButton :label="labels.get('Mx')" value="Mx." v-model="formData.title"></RadioButton>
        <RadioButton :label="labels.get('Dr')" value="Dr." v-model="formData.title"></RadioButton>
      </RadioButtonGroup>
    </div>
    <div class="form-row">
      <div>
        <div class="form-row">
          <TextBox :label="labels.get('Your name')" v-model="formData.firstName" :invalid="invalidFields.firstName"
            :placeholder="labels.get('First name')" mandatory @change="validateField('firstName')"></TextBox>
          <TextBox :label="labels.get('Last name')" v-model="formData.lastName" :placeholder="labels.get('Last name')"
            @change="validateField('lastName')" :invalid="invalidFields.lastName"></TextBox>
        </div>
        <div class="form-row">
          <TextBox :label="labels.get('Your email')" v-model="formData.email" @change="validateField('email')"
            :invalid="invalidFields.email" :placeholder="labels.get('Email address')" mandatory></TextBox>
          <TextBox :label="labels.get('Phone')" v-model="formData.phone" :placeholder="labels.get('Phone number')">
          </TextBox>
        </div>
        <TextBox :label="labels.get('Your company')" v-model="formData.company" :placeholder="labels.get('Company name')">
        </TextBox>
        <DropList :label="labels.get('Country')" :data="countries" v-model="formData.country" filterable mandatory
          @change="onCountryChanged" :invalid="invalidFields.country"></DropList>
        <DropList :label="labels.get('Request type')" :data="filteredRequestTypes" v-model="formData.requestType"
          filterable></DropList>
      </div>
      <div>
        <NoteBox :label="labels.get('Message')" v-model="formData.message" @change="validateField('message')"
          :invalid="invalidFields.message" :placeholder="labels.get('Your message here')" :rows="20" class="messagebox">
        </NoteBox>
      </div>
    </div>
    <div>
      <CheckboxGroup>
        <Checkbox :label="labels.get('Ack1')" mandatory v-model="formData.ack1" :invalid="invalidFields.ack1"
          @change="validateField('ack1')"></Checkbox>
        <Checkbox :label="labels.get('Ack2')" v-model="formData.ack2"></Checkbox>
      </CheckboxGroup>
    </div>
  </div>
</template>

<script>
import ServiceManager from "../services/service-manager";
import {
  RadioButtonGroup,
  RadioButton,
  NoteBox,
  TextBox,
  DropList,
  CheckboxGroup,
  Checkbox,
} from "clariant-vue3-forms";

export default {
  name: "ContactFormGeneral",
  components: {
    RadioButtonGroup,
    RadioButton,
    NoteBox,
    TextBox,
    DropList,
    CheckboxGroup,
    Checkbox,
  },
  props: ["tag", "bu", "bl", "country", "region", "contact"],
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      config: ServiceManager.getService(this, "Config"),
      state: ServiceManager.getService(this, "State"),
      utils: ServiceManager.getService(this, "Utils"),
      dataLayer: ServiceManager.getService(this, "DataLayer"),
      formData: {
        contact: null,
        title: "Mr.",
        message: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        country: "",
        requestType: "",
        ack1: false,
        ack2: false,
      },
      invalidFields: {
        firstName: false,
        lastName: false,
        email: false,
        message: false,
        ack1: false,
        country: false,
      },
      countries: [],
      requestTypes: [],
    };
  },
  setup() {
    return {
      uniqueId: `ContactFormGeneral-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`
    }
  },
  mounted() {
    this.state.subscribe(
      this.uniqueId,
      this.onStateChanged
    );
    this.countries = this.dataLayer.loadCountries();
    this.requestTypes = this.dataLayer.loadRequestTypes();
    this.formData.country = this.state.get("country");
    this.formData.requestType =
      this.requestTypes && this.requestTypes.length > 0
        ? this.requestTypes[0].id
        : "";
    this.formData.contact = this.contact;
  },
  beforeUnmount() {
    this.state.unsubscribe(this.uniqueId);
  },
  watch: {
    contact(val) {
      this.formData.contact = val;
    },
  },
  computed: {
    filteredRequestTypes() {
      if (!this.contact) return [];
      if (!this.contact.topics || this.contact.topics.length === 0) return this.requestTypes;
      return this.requestTypes.filter(x => this.contact.topics.includes(x.id));
    }
  },
  methods: {
    onStateChanged(msg, prop, value) {
      if (prop === "countries") {
        this.countries = value;
      } else if (prop === "requestTypes") {
        this.requestTypes = value;
        this.formData.requestType =
          this.requestTypes && this.requestTypes.length > 0
            ? this.requestTypes[0].id
            : "";
      } else if (prop === "country") {
        this.formData.country = value;
      } else if (msg === "clear") {
        this.clearForm();
      }
    },
    clearForm() {
      this.formData.message = "";
      this.invalidFields.message = false;
      this.invalidFields.ack1 = false;
      this.invalidFields.firstName = false;
      this.invalidFields.lastName = false;
      this.invalidFields.email = false;
      this.invalidFields.country = false;
    },
    onCountryChanged(e) {
      this.state.set("country", e.value);
    },
    validateField(fieldName) {
      if (fieldName === "email") {
        this.invalidFields[fieldName] = !this.utils.isEmail(
          this.formData[fieldName]
        );
      } else {
        this.invalidFields[fieldName] = !this.formData[fieldName];
      }
      return !this.invalidFields[fieldName];
    },
    validateForm() {
      let ret = true;
      if (!this.validateField("firstName")) ret = false;
      if (!this.validateField("lastName")) ret = false;
      if (!this.validateField("email")) ret = false;
      if (!this.validateField("message")) ret = false;
      if (!this.validateField("ack1")) ret = false;
      if (!this.validateField("country")) ret = false;

      return ret;
    },
    getFormPayload() {
      return this.formData;
    },
  },
};
</script>

<style>
.contact-form.general .form-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.contact-form.general .form-row>* {
  width: 48% !important;
  align-self: flex-end;
  flex-wrap: wrap;
}

.contact-form.general .messagebox textarea {
  height: 366px;
}

.contact-form.general .cla-droplist-container .options-container {
  max-height: 170px !important;
}

@media all and (max-width: 980px) {
  .contact-form.general .form-row {
    flex-direction: column;
  }

  .contact-form.general .form-row>* {
    width: 100% !important;
  }
}
</style>